import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { consumeOAuthReturnLanguage } from "../../utils/socialSignIn";

/**
 * Renders nothing. When a Google/Facebook round-trip failed (cancelled, permission
 * refused, no email, an account with that email already exists, ...), the browser
 * is dropped back on the site root with nothing on screen to say so. This sends the
 * person to the login page, in the language they started in, which shows the
 * translated reason and keeps every other way in (email, Google, Facebook) one
 * click away. The history entry is replaced, so Back does not return to a dead
 * "/?error=..." page and a refresh does not repeat the message.
 */
function SocialSignInErrorRedirect() {
    const { oauthError, clearOauthError } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!oauthError) return;
        const loginPath = consumeOAuthReturnLanguage() === "pt" ? "/pt/login" : "/login";
        clearOauthError();
        navigate(loginPath, { replace: true, state: { socialError: oauthError } });
    }, [oauthError, clearOauthError, navigate]);

    return null;
}

export default SocialSignInErrorRedirect;
